import { getKeycloakRoles } from '@/features/Keycloak/keycloakService';
import { FeatureName, Role } from '@/models/role.models';

const permissionMatrix: { [key in FeatureName]: Role[] } = {
  // Customer
  [FeatureName.DELETE_CUSTOMER]: [Role.ADMIN],
  [FeatureName.VIEW_AUDIT_HISTORY]: [Role.ADMIN, Role.VIEWER, Role.OPERATOR],
  [FeatureName.VIEW_EDIT_CUSTOMER_PAGE]: [Role.ADMIN],
  [FeatureName.VIEW_LIST_CUSTOMERS_PAGE]: [Role.ADMIN],
  [FeatureName.VIEW_LIST_USERS_PAGE]: [Role.ADMIN],

  // Device
  [FeatureName.ASSIGN_USERS_TO_DEVICE]: [Role.ADMIN],
  [FeatureName.CREATE_DEVICES]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.CREATE_UPDATE_API_KEYS]: [Role.ADMIN],
  [FeatureName.CREATE_UPDATE_ROI]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.DELETE_DEVICE]: [Role.ADMIN],
  [FeatureName.UPDATE_DEVICE]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.UPDATE_DEVICE_DISABLED_STATUS]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.UPDATE_DEVICE_INSTALL_STATUS]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.INSTALLER,
  ],
  [FeatureName.UPDATE_DEVICE_PRODUCTION_STATUS]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_API_KEYS]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_ASSIGNED_USERS]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_DEVICE_CONFIG]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_DEVICES_GRID_MODE]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.VIEWER,
  ],
  [FeatureName.VIEW_EDIT_DEVICE_PAGE]: [
    Role.ADMIN,
    Role.INSTALLER,
    Role.OPERATOR,
    Role.VIEWER,
  ],
  [FeatureName.VIEW_GRAFANA_BUTTON]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_LIST_DEVICES_PAGE]: [
    Role.ADMIN,
    Role.INSTALLER,
    Role.OPERATOR,
    Role.VIEWER,
  ],
  [FeatureName.VIEW_ROI_ZONE]: [Role.ADMIN, Role.OPERATOR, Role.VIEWER],
  [FeatureName.VIEW_DEVICE_COMPARE_PAGE]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.VIEWER,
  ],

  // Site
  [FeatureName.ASSIGN_DEVICES_TO_SITE]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.CREATE_SITE]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.CREATE_UPDATE_SITE_LOCATION]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.DELETE_SITE]: [Role.ADMIN],
  [FeatureName.UPDATE_SITE]: [Role.ADMIN, Role.OPERATOR],
  [FeatureName.VIEW_EDIT_SITE_METADATA]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.INSTALLER,
    Role.VIEWER,
  ],
  [FeatureName.VIEW_EDIT_SITE_PAGE]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.INSTALLER,
    Role.VIEWER,
  ],
  [FeatureName.VIEW_LIST_SITES_PAGE]: [
    Role.ADMIN,
    Role.OPERATOR,
    Role.INSTALLER,
    Role.VIEWER,
  ],
};

export default function hasPermission(feature: FeatureName): boolean {
  const userRoles = getKeycloakRoles() ?? [];
  if (userRoles.length === 0) {
    // For whatever reason the user does not have any role assigned, block him.
    return false;
  }
  const allowedRoles = permissionMatrix[feature];
  if (allowedRoles.length === 0) {
    //Everyone has permission to the feature, If no role is specified in the Permission Matrix for certain feature.
    return true;
  } else {
    for (const allowedRole of allowedRoles) {
      if (userRoles.includes(allowedRole)) {
        return true;
      }
    }
    return false;
  }
}
